import Immutable from 'immutable';
import {ReduceStore} from 'flux/utils';

import AppConstants from 'AppConstants';
import {DesignerAction, UserAction} from 'AppAction';
import CacheService from 'service/CacheService';

import Dispatcher from 'service/Dispatcher';

class DesignerStore extends ReduceStore {

	constructor() {
		super(Dispatcher);

		this.DESIGNER_BALANCE = "DESIGNER_BALANCE";
		this.DESIGNER_PENDING_ORDERS = "DESIGNER_PENDING_ORDERS";
		this.ALL_STORES = DesignerAction.LOAD_ALL_STORES;
	}

	getInitialState() {
		this.POPULAR_STORES = "POPULAR_STORES";
		const map = Immutable.Map();
		const popularStores = JSON.parse(CacheService.get(this.POPULAR_STORES));

		if(popularStores) {
			return map.set(this.POPULAR_STORES, Immutable.List(popularStores));
		} else {
			return map;
		}
	}

	getDesignerBalance() {
		return this.getState().get(this.DESIGNER_BALANCE) || null;
	}

	getAllPendingOrders() {
		return this.getState().get(this.DESIGNER_PENDING_ORDERS) || null;
	}

	getPopularStores() {
		if(this.getState().get(this.POPULAR_STORES))
			return this.getState().get(this.POPULAR_STORES)
						.filter(s => s.userType !== AppConstants.USER_TYPE.INFLUENCER);
		
		return null;
	}

	getAllPopularStores() {
		if(this.getState().get(this.POPULAR_STORES))
			return this.getState().get(this.POPULAR_STORES)
		
		return null;
	}

	getAllStores() {
		if(this.getState().get(this.ALL_STORES))
			return this.getState().get(this.ALL_STORES);
		
		return null;
	}

	getAllArtist(prefix) {
		const allArtists = this.getState().get(DesignerAction.LOAD_ALL_ARTISTS+"_"+prefix.toUpperCase());
		if(allArtists === null || allArtists === undefined) return null;

		return allArtists;
	}

	getPopularInfluencers() {
		if(this.getState().get(this.POPULAR_STORES))
			return this.getState().get(this.POPULAR_STORES)
						.filter(s => s.userType === AppConstants.USER_TYPE.INFLUENCER);
		
		return null;
	}


	getStoreInfo(storeName) {
		return this.getState().get(UserAction.LOAD_USER_PROFILE+"_"+storeName.toUpperCase()) || null;
	}

	getDesignerInfo(userId) {
		return this.getState().get(UserAction.LOAD_USER_PROFILE+"_"+userId) || null;
	}

	_upateUserProfile(state, updatedUser) {
		const updatedState = state.set(UserAction.LOAD_USER_PROFILE+"_"+updatedUser.id, updatedUser);
		if(updatedUser.storeName)
			return updatedState.set(UserAction.LOAD_USER_PROFILE+"_"+updatedUser.storeName.toUpperCase(), updatedUser);
		else
			return updatedState;
	}

	getPopularArtists() {
		return this.getState().get(DesignerAction.LOAD_POPULAR_ARTISTS) || null;
	}

	getActiveArtists() {
		return this.getState().get(DesignerAction.LOAD_ACTIVE_ARTISTS) || null;
	}

	reduce(state, action) { 

		switch (action.type) {
			case DesignerAction.LOAD_BALANCE:
				return state.set(this.DESIGNER_BALANCE, action.balance);

			case DesignerAction.LOAD_ALL_PENDING_ORDERS:
				return state.set(this.DESIGNER_PENDING_ORDERS, Immutable.List(action.orders));

			case DesignerAction.LOAD_POPULAR_STORES:
				CacheService.save(this.POPULAR_STORES, JSON.stringify(action.stores));
				return state.set(this.POPULAR_STORES, Immutable.List(action.stores));

			case DesignerAction.LOAD_ALL_STORES:
				return state.set(this.ALL_STORES, Immutable.List(action.stores));

			case UserAction.LOAD_USER_PROFILE:
				return this._upateUserProfile(state, action.userInfo);
				
			case UserAction.BANNER_UPDATE:
				return this._upateUserProfile(state, action.user);

			case UserAction.PROFILE_PIC_UPDATE:
				return this._upateUserProfile(state, action.user);

			case DesignerAction.LOAD_ACTIVE_ARTISTS:
				return state.set(DesignerAction.LOAD_ACTIVE_ARTISTS, Immutable.List(action.artists));

			case DesignerAction.LOAD_POPULAR_ARTISTS:
				return state.set(DesignerAction.LOAD_POPULAR_ARTISTS, Immutable.List(action.artists));

			case DesignerAction.LOAD_ALL_ARTISTS:
				return state.set(DesignerAction.LOAD_ALL_ARTISTS+"_"+action.prefix.toUpperCase(), Immutable.List(action.artists));

			case UserAction.LOGOUT:
				return state.clear();
			default:
				break;

		}
		return state;
	}
}


export default new DesignerStore();


// WEBPACK FOOTER //
// ./src/stores/DesignerStore.js